import React from 'react';
import { LocationPrecision } from '../../hooks/useLocation';

interface Props {
  precision: LocationPrecision;
  onPrecisionChange: (p: LocationPrecision) => void;
  radius: number | null;
  onRadiusChange: (r: number | null) => void;
}

const PRECISIONS: { key: LocationPrecision; label: string; desc: string }[] = [
  { key: 'exact',       label: 'Exact',  desc: 'Real GPS coords' },
  { key: 'approximate', label: 'Fuzzy',  desc: '~150 m accuracy' },
  { key: 'hidden',      label: 'Hidden', desc: 'Off the map' },
];

const RADII = [
  { val: 1,    label: '1 km' },
  { val: 5,    label: '5 km' },
  { val: 25,   label: '25 km' },
  { val: null, label: 'Global' },
];

export function MapControls({ precision, onPrecisionChange, radius, onRadiusChange }: Props) {
  return (
    <div className="flex flex-col gap-4">
      <div>
        <p className="section-label">My location</p>
        <div className="flex gap-2">
          {PRECISIONS.map(p => (
            <button
              key={p.key}
              onClick={() => onPrecisionChange(p.key)}
              className={`flex-1 py-2 px-3 rounded-xl text-xs font-medium transition-all ${
                precision === p.key ? 'pill-active' : 'pill-inactive'
              }`}
            >
              {p.label}
              <span className="block text-[10px] opacity-60 mt-0.5">{p.desc}</span>
            </button>
          ))}
        </div>
      </div>

      <div>
        <p className="section-label">Show people within</p>
        <div className="flex gap-2">
          {RADII.map(r => (
            <button
              key={String(r.val)}
              onClick={() => onRadiusChange(r.val)}
              className={`flex-1 py-2 rounded-xl text-xs font-medium transition-all ${
                radius === r.val ? 'pill-active' : 'pill-inactive'
              }`}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
